import { useConnectivity } from '@/offline/useConnectivity';
import { useSyncStatus } from '@/offline/useSyncStatus';

/**
 * "You are offline", for screen readers only (2026-10-09). This was a band
 * fixed across the top of the screen, and from 2026-07-10 the shared NADC bar
 * (fixed, z-index 1000) covered it whenever the bar loaded, so it was all but
 * never seen; the header's sync pill is what reads "Offline". When DemoOps
 * stopped loading the bar (Michael, to save screen space) the band lay over
 * DemoOps' own header instead: the wordmark and the title cut in half, the
 * top of the header buttons dead to a tap. Visually hidden keeps the screen
 * as it was, costs no room and still announces the changes waiting. A band
 * on screen would have to sit in normal flow like PreviewBanner, taking its
 * height off the shells, never over the header.
 */
export function ConnectivityIndicator() {
  const { isOnline } = useConnectivity();
  const { pendingCount } = useSyncStatus();

  // Only announced while offline
  if (isOnline) {
    return null;
  }

  return (
    <div className="sr-only" role="status" aria-live="polite">
      <span>
        You are offline
        {pendingCount > 0 && ` • ${pendingCount} change${pendingCount !== 1 ? 's' : ''} pending`}
      </span>
    </div>
  );
}
